var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdfWrapper"},[_c('vue-pdf-embed',{ref:"pdfRef",staticStyle:{"width":"100%","height":"100%"},attrs:{"source":_vm.source,"page":_vm.page},on:{"rendered":_vm.handleDocumentRender}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }